export const NAVBAR_HAMBURGER_ICON_CLICK = "Navbar_Hamburger_Icon_Click";
export const NAVBAR_LOGO_CLICK = "Navbar_Logo_Click";
export const NAVBAR_SEARCH_INPUT_CLICK = "Navbar_Search_Input_Click";
export const NAVBAR_NOTIFICATION_ICON_CLICK = "Navbar_Notification_Icon_Click";
export const NAVBAR_PROFILE_PIC_CLICK = "Navbar_Profile_Pic_Click";
export const NAVBAR_PROFILE_PIC_PPOFILE_OPTION_CLICK =
  "Navbar_Profile_Pic_Profile_Option_Click";
export const NAVBAR_PROFILE_PIC_LOGOUT_OPTION_CLICK =
  "Navbar_Profile_Pic_Logout_Option_Click";
